module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-20 w-500 bor-gray m-b-30"
  }, [_c('div', {
    staticClass: "h-30"
  }, [_vm._v("大小限制")]), _vm._v(" "), _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.curInput.image.size,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片大小(KB)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.size.config),
      expression: "curInput.image.size_limit.size.config"
    }],
    staticClass: "w-300 m-r-20",
    attrs: {
      "disabled": _vm.curInput.image.size_limit.size.is_limited == 0
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.size.config)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.size_limit.size.config = $event
      }
    }
  }), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.size.is_limited),
      expression: "curInput.image.size_limit.size.is_limited"
    }],
    attrs: {
      "true-label": 0,
      "false-label": 1
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.size.is_limited)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.size_limit.size.is_limited = $event
      }
    }
  }, [_vm._v("不限制")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "高限制(PX)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.height.config[0]),
      expression: "curInput.image.size_limit.height.config[0]"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "disabled": _vm.curInput.image.size_limit.height.is_limited == 0
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.height.config[0])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.size_limit.height.config,
          $$idx = 0;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.size_limit.height.config[0] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v("~"), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.height.config[1]),
      expression: "curInput.image.size_limit.height.config[1]"
    }],
    staticClass: "w-140 m-l-10 m-r-20",
    attrs: {
      "disabled": _vm.curInput.image.size_limit.height.is_limited == 0
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.height.config[1])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.size_limit.height.config,
          $$idx = 1;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.size_limit.height.config[1] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.height.is_limited),
      expression: "curInput.image.size_limit.height.is_limited"
    }],
    attrs: {
      "true-label": 0,
      "false-label": 1
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.height.is_limited)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.size_limit.height.is_limited = $event
      }
    }
  }, [_vm._v("不限制")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宽限制(PX)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.width.config[0]),
      expression: "curInput.image.size_limit.width.config[0]"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "disabled": _vm.curInput.image.size_limit.width.is_limited == 0
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.width.config[0])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.size_limit.width.config,
          $$idx = 0;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.size_limit.width.config[0] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v("~"), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.width.config[1]),
      expression: "curInput.image.size_limit.width.config[1]"
    }],
    staticClass: "w-140 m-l-10 m-r-20",
    attrs: {
      "disabled": _vm.curInput.image.size_limit.width.is_limited == 0
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.width.config[1])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.size_limit.width.config,
          $$idx = 1;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.size_limit.width.config[1] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.size_limit.width.is_limited),
      expression: "curInput.image.size_limit.width.is_limited"
    }],
    attrs: {
      "true-label": 0,
      "false-label": 1
    },
    domProps: {
      "value": (_vm.curInput.image.size_limit.width.is_limited)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.size_limit.width.is_limited = $event
      }
    }
  }, [_vm._v("不限制")])])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "p-20 w-500 bor-gray m-b-30"
  }, [_c('div', {
    staticClass: "h-30"
  }, [_vm._v("图片处理")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-5 m-b-10"
  }, [_c('span', {
    staticClass: "m-r-15"
  }, [_vm._v("处理方式")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.type),
      expression: "curInput.image.deal_config.type"
    }],
    domProps: {
      "value": (_vm.curInput.image.deal_config.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("不处理")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("前端处理")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 30
    }
  }, [_vm._v("后端处理")])])]), _vm._v(" "), (_vm.curInput.image.deal_config.type != 10) ? _c('div', [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.is_zoom),
      expression: "curInput.image.deal_config.is_zoom"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.is_zoom)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.is_zoom = $event
      }
    }
  }, [_vm._v("缩放")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  }, [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("尺寸")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.zoom_config.height),
      expression: "curInput.image.deal_config.zoom_config.height"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高",
      "disabled": _vm.curInput.image.deal_config.is_zoom == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.zoom_config.height)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.zoom_config.height = $event
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.zoom_config.width),
      expression: "curInput.image.deal_config.zoom_config.width"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽",
      "disabled": _vm.curInput.image.deal_config.is_zoom == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.zoom_config.width)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.zoom_config.width = $event
      }
    }
  })]), _vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.curInput.image.deal_config.type == 20) ? _c('div', [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.is_fix_scale),
      expression: "curInput.image.deal_config.is_fix_scale"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.is_fix_scale)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.is_fix_scale = $event
      }
    }
  }, [_vm._v("选框固定比例")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("高宽比")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.fix_scale_config[0]),
      expression: "curInput.image.deal_config.fix_scale_config[0]"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高",
      "disabled": _vm.curInput.image.deal_config.is_fix_scale == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.fix_scale_config[0])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.deal_config.fix_scale_config,
          $$idx = 0;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.deal_config.fix_scale_config[0] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.fix_scale_config[1]),
      expression: "curInput.image.deal_config.fix_scale_config[1]"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽",
      "disabled": _vm.curInput.image.deal_config.is_fix_scale == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.fix_scale_config[1])
    },
    on: {
      "input": function($event) {
        var $$exp = _vm.curInput.image.deal_config.fix_scale_config,
          $$idx = 1;
        if (!Array.isArray($$exp)) {
          _vm.curInput.image.deal_config.fix_scale_config[1] = $event
        } else {
          $$exp.splice($$idx, 1, $event)
        }
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.curInput.image.deal_config.type == 30) ? _c('div', [_c('div', [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.is_cut),
      expression: "curInput.image.deal_config.is_cut"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.is_cut)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.is_cut = $event
      }
    }
  }, [_vm._v("裁剪")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("尺寸(PX)")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.cut_config.height),
      expression: "curInput.image.deal_config.cut_config.height"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高",
      "disabled": _vm.curInput.image.deal_config.is_cut == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.cut_config.height)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.cut_config.height = $event
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.cut_config.width),
      expression: "curInput.image.deal_config.cut_config.width"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽",
      "disabled": _vm.curInput.image.deal_config.is_cut == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.cut_config.width)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.cut_config.width = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-b-10"
  }, [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("裁剪位置")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.cut_config.position),
      expression: "curInput.image.deal_config.cut_config.position"
    }],
    domProps: {
      "value": (_vm.curInput.image.deal_config.cut_config.position)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.cut_config.position = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10,
      "disabled": _vm.curInput.image.deal_config.is_cut == 0
    }
  }, [_vm._v("居中裁切")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20,
      "disabled": _vm.curInput.image.deal_config.is_cut == 0
    }
  }, [_vm._v("左上角裁切")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.is_compress),
      expression: "curInput.image.deal_config.is_compress"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.is_compress)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.is_compress = $event
      }
    }
  }, [_vm._v("质量压缩")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("质量度")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.deal_config.compress_quality),
      expression: "curInput.image.deal_config.compress_quality"
    }],
    staticClass: "w-400",
    attrs: {
      "placeholder": "0-100",
      "disabled": _vm.curInput.image.deal_config.is_compress == 0
    },
    domProps: {
      "value": (_vm.curInput.image.deal_config.compress_quality)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.deal_config.compress_quality = $event
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "p-20 w-500 bor-gray m-b-30"
  }, [_c('div', {
    staticClass: "h-30"
  }, [_vm._v("缩略图")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-b-10"
  }, [_c('span', {
    staticClass: "m-r-10"
  }, [_vm._v("是否生成缩略图")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.thumb_config.is_thumb),
      expression: "curInput.image.thumb_config.is_thumb"
    }],
    domProps: {
      "value": (_vm.curInput.image.thumb_config.is_thumb)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.thumb_config.is_thumb = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不生成")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("生成")])])]), _vm._v(" "), _vm._l((_vm.curInput.image.thumb_config.config), function(item, index) {
    return (_vm.curInput.image.thumb_config.is_thumb) ? _c('div', {
      staticClass: "bor-gray p-20 m-b-10 pos-rel"
    }, [(index != 0) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "top": "20px",
        "right": "20px",
        "color": "red",
        "cursor": "pointer",
        "z-index": "1000"
      },
      on: {
        "click": function($event) {
          _vm.deleteThumb(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-form', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "form",
      refInFor: true,
      attrs: {
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "尺寸(PX)"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.height),
        expression: "item.height"
      }],
      staticClass: "w-140 m-r-10",
      attrs: {
        "placeholder": "高"
      },
      domProps: {
        "value": (item.height)
      },
      on: {
        "input": function($event) {
          item.height = $event
        }
      }
    }), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.width),
        expression: "item.width"
      }],
      staticClass: "w-140",
      attrs: {
        "placeholder": "宽"
      },
      domProps: {
        "value": (item.width)
      },
      on: {
        "input": function($event) {
          item.width = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "缩放处理方式"
      }
    }, [_c('el-radio-group', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.thumb_type),
        expression: "item.thumb_type"
      }],
      domProps: {
        "value": (item.thumb_type)
      },
      on: {
        "input": function($event) {
          item.thumb_type = $event
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 10
      }
    }, [_vm._v("拉伸")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 20
      }
    }, [_vm._v("高度适应裁切")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 30
      }
    }, [_vm._v("宽度适应裁切")])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.curInput.image.thumb_config.is_thumb) ? _c('button', {
    staticClass: "w-100p",
    staticStyle: {
      "height": "36px",
      "background-color": "#5bb1fa",
      "border": "0",
      "color": "#ffffff",
      "border-radius": "3px",
      "outline": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addThumb
    }
  }, [_vm._v("增加")]) : _vm._e()], true), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "p-20 w-500 bor-gray m-b-30"
  }, [_c('div', {
    staticClass: "h-30"
  }, [_vm._v("列表/表单只读显示")]), _vm._v(" "), _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表单中只读尺寸(PX)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.display_config.form_display.height),
      expression: "curInput.image.display_config.form_display.height"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高"
    },
    domProps: {
      "value": (_vm.curInput.image.display_config.form_display.height)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.display_config.form_display.height = $event
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.display_config.form_display.width),
      expression: "curInput.image.display_config.form_display.width"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽"
    },
    domProps: {
      "value": (_vm.curInput.image.display_config.form_display.width)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.display_config.form_display.width = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "列表尺寸(PX)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.display_config.list_display.height),
      expression: "curInput.image.display_config.list_display.height"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高"
    },
    domProps: {
      "value": (_vm.curInput.image.display_config.list_display.height)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.display_config.list_display.height = $event
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.display_config.list_display.width),
      expression: "curInput.image.display_config.list_display.width"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽"
    },
    domProps: {
      "value": (_vm.curInput.image.display_config.list_display.width)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.display_config.list_display.width = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "鼠标悬浮显示大图(PX)"
    }
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.display_config.suspension_type),
      expression: "curInput.image.display_config.suspension_type"
    }],
    domProps: {
      "value": (_vm.curInput.image.display_config.suspension_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.display_config.suspension_type = $event
      }
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("表单")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("列表")])])])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "p-20 w-500 bor-gray m-b-30"
  }, [_c('div', {
    staticClass: "h-30"
  }, [_vm._v("移动端配置")]), _vm._v(" "), _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表单中只读尺寸(PX)"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.mobile_config.readonly_size_form.height),
      expression: "curInput.image.mobile_config.readonly_size_form.height"
    }],
    staticClass: "w-140 m-r-10",
    attrs: {
      "placeholder": "高"
    },
    domProps: {
      "value": (_vm.curInput.image.mobile_config.readonly_size_form.height)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.mobile_config.readonly_size_form.height = $event
      }
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.image.mobile_config.readonly_size_form.width),
      expression: "curInput.image.mobile_config.readonly_size_form.width"
    }],
    staticClass: "w-140",
    attrs: {
      "placeholder": "宽"
    },
    domProps: {
      "value": (_vm.curInput.image.mobile_config.readonly_size_form.width)
    },
    on: {
      "input": function($event) {
        _vm.curInput.image.mobile_config.readonly_size_form.width = $event
      }
    }
  })]), _vm._v(" ")])])]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf97a034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/photoConfig.vue
// module id = 1993
// module chunks = 2